import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

interface InkH1Props extends HTMLAttributes<HTMLHeadingElement> {
  inkGradient?: boolean;
}

export function InkH1({ className, inkGradient = false, children, ...props }: InkH1Props) {
  return (
    <h1
      className={cn(
        'text-3xl font-extrabold tracking-tight text-[var(--text-primary)]',
        inkGradient && 'bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent',
        className
      )}
      {...props}
    >
      {children}
    </h1>
  );
}
